(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-banner"] && !Shopify.designMode) return;
  try {
    
  class EmailBanner {
    #storageKey = 'emailBannerPending';

    constructor(section) {
      this.section = section;
      this.sectionKey = section.id.replace('EmailBanner-', '');
      this.form = section.querySelector('.email-banner__form');
      this.dialog = section.querySelector('dialog');

      this.#bindDialog();
      this.#bindForm();
      this.#checkSuccessState();
    }

    #bindForm() {
      if (!this.form) return;

      this.form.addEventListener('submit', () => {
        sessionStorage.setItem(this.#storageKey, this.sectionKey);
      });
    }

    #bindDialog() {
      if (!this.dialog) return;

      this.section.querySelectorAll('[data-email-banner-close]').forEach((button) => {
        button.addEventListener('click', () => this.dialog.close());
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          this.dialog.close();
        }
      });
    }

    #hasFormError() {
      return Boolean(this.section.querySelector('.email-banner__error'));
    }

    #checkSuccessState() {
      if (this.#hasFormError()) {
        sessionStorage.removeItem(this.#storageKey);
        return;
      }

      const params = new URLSearchParams(window.location.search);
      const urlSuccess = params.get('email_banner_success');
      const pendingSection = sessionStorage.getItem(this.#storageKey);

      const shouldOpen =
        this.dialog?.hasAttribute('data-show-success') ||
        urlSuccess === this.sectionKey ||
        params.get('customer_posted') === 'true' ||
        pendingSection === this.sectionKey;

      if (!shouldOpen) return;

      sessionStorage.removeItem(this.#storageKey);
      this.#openDialog();

      if (urlSuccess === this.sectionKey) {
        params.delete('email_banner_success');
        const query = params.toString();
        const nextUrl = query
          ? `${window.location.pathname}?${query}${window.location.hash}`
          : `${window.location.pathname}${window.location.hash}`;
        window.history.replaceState({}, '', nextUrl);
      }
    }

    #openDialog() {
      if (!this.dialog) return;

      try {
        if (!this.dialog.open && typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
          return;
        }
      } catch (error) {
        // Fallback for browsers that reject showModal in edge cases.
      }

      if (!this.dialog.open) {
        this.dialog.setAttribute('open', '');
      }
    }
  }

  const initEmailBanners = () => {
    document.querySelectorAll('.email-banner').forEach((section) => {
      new EmailBanner(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmailBanners);
  } else {
    initEmailBanners();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
